module.exports = __webpack_public_path__ + "img/cup-3-stars.d60d48ca.svg";